import _ from 'lodash'
import { call, put, select, takeLatest } from 'redux-saga/effects'

import CONSTANTS from 'core/data-model/constants/values'
import { UPDATE_BIRTHDATE } from 'quick-quote/insured-information/actions'
import { editSumAssured, editBasicPremiumState } from 'quick-quote/product-common/coverage-plan/actions'
import { getSumAssured } from 'quick-quote/product-common/coverage-plan/selectors'
import { getDisplayProducts, getSelectedDisplayProductCode } from 'quick-quote/product-selection/selectors'

import { SELECT_PRODUCT_TERM_LIFE, selectBasicPlan } from './actions'
import {
  getSelectableProductUltimateGrowth,
  getSelectableProductGlobalIndex,
  getSelectableProductGlobalIndex25_5,
  getSelectableProductGlobalIndex15_8,
  getSelectedProductValidOrDefault,
} from './coverage-plan/selectors'

/**
 * crateProductTermLifeFunc
 * @param {ReturnType<import('quick-quote/product-common/coverage-plan/sagas').createProductCommonCoverageFunc>} productCommonCoverageFunc
 */
export function crateProductTermLifeFunc(productCommonCoverageFunc) {
  const onUpdateSelectedTermLife = function*(action) {
    const displayProducts = yield select(getDisplayProducts)
    const productSelected = _.find(displayProducts, { code: action.payload })
    if (productSelected) {
      const sumAssured = yield select(getSumAssured)
      yield put(selectBasicPlan(productSelected))
      yield put(editSumAssured(sumAssured))
      yield put(editBasicPremiumState(-1))
    }
  }

  const switchTermLifeGroupProductByAge = function*(action) {
    const productCode = yield select(getSelectedDisplayProductCode)
    let selectableProducts
    switch (productCode) {
      case 'E20F10':
      case 'E25F15':
      case 'E25F25': {
        selectableProducts = yield select(getSelectableProductUltimateGrowth)
        break
      }
      case 'E16G6A':
      case 'E16G6AS': {
        selectableProducts = yield select(getSelectableProductGlobalIndex)
        break
      }
      case 'E25G5A':
      case 'E25G5AS': {
        selectableProducts = yield select(getSelectableProductGlobalIndex25_5)
        break
      }
      case 'E15G8A':
      case 'E15G8AS': {
        selectableProducts = yield select(getSelectableProductGlobalIndex15_8)
        break
      }
      default:
        selectableProducts = yield select(getSelectableProductUltimateGrowth)
    }

    const selectedProductCode = getSelectedProductValidOrDefault(selectableProducts, productCode)
    if (
      !!selectedProductCode &&
      selectedProductCode !== productCode &&
      (CONSTANTS.ULTIMATE_GROWTH_CODE_GROUP.includes(productCode) ||
        Object.values(CONSTANTS.GLOBAL_INDEX_16_6_CODE).includes(productCode) ||
        Object.values(CONSTANTS.INDEX_LINKED_25_5_CODE).includes(productCode) ||
        Object.values(CONSTANTS.INDEX_LINKED_15_8_CODE).includes(productCode))
    ) {
      const displayProducts = yield select(getDisplayProducts)
      const productSelected = _.find(displayProducts, { code: selectedProductCode })
      yield put(selectBasicPlan(productSelected))
      yield call(productCommonCoverageFunc.populateAvailableRiders)
    }
  }

  return {
    onUpdateSelectedTermLife,
    switchTermLifeGroupProductByAge,
  }
}

/**
 * @param serviceWrapper {Awaited<ReturnType<import('core/service-wrapper/wrapper').buildServiceWrapper>>}
 */
export function* watchers(serviceWrapper) {
  const { TERM_LIFE } = serviceWrapper.products
  yield [
    takeLatest([UPDATE_BIRTHDATE], TERM_LIFE.switchTermLifeGroupProductByAge),
    takeLatest([SELECT_PRODUCT_TERM_LIFE], TERM_LIFE.onUpdateSelectedTermLife),
  ]
}

export const sagas = watchers
